<div class="wrap">
  <h3>Choisissez une ligue : </h3>
  <select [(ngModel)]="data.fluxLigue ">
    <!-- <option [value]="0" selected>-- Selectionnez une ligue --</option> -->
    <ng-container *ngFor="let l of allLigues">
      <option [value]="l.denomination">{{l.code}} - {{l.denomination}}</option>
    </ng-container>
  </select>
  <div class="btn_action">
    <button type="button" class="back" [mat-dialog-close]=" data.load === false">Annuler</button>
    <button [mat-dialog-close]=" data.fluxLigue" class="confirm">Confirmer</button>
  </div>
</div>